export default {
  round(number, precision) {
    let pow = Math.pow(10, precision = 2);
    return Math.round(number * pow)/pow;
  }
}


// WEBPACK FOOTER //
// src/helpers/pMath.js